// Locks document scrolling while a bottom-sheet overlay (history panel,
// text-search sheet) is open, so touch scrolls stay inside the overlay
// instead of moving the details view behind it. Reference-counted so two
// overlays (or fast open/close) can't unlock each other early.
//
// Uses the fixed-body technique: plain `overflow: hidden` on the root would
// clamp the document scroll to 0, visibly jumping the page to the top under
// the sheet and losing the reading position on close. Pinning the body at
// `top: -scrollY` keeps the view where it was; unlock restores the offset.
import { onBeforeUnmount, onMounted } from 'vue';

let locks = 0;
let savedScrollY = 0;

export function lockBodyScroll(): void {
  locks += 1;
  if (locks > 1) return;
  savedScrollY = window.scrollY;
  const { style } = document.body;
  style.position = 'fixed';
  style.top = `-${savedScrollY}px`;
  style.left = '0';
  style.right = '0';
  style.width = '100%';
  document.documentElement.classList.add('scroll-locked');
}

export function unlockBodyScroll(): void {
  locks = Math.max(0, locks - 1);
  if (locks > 0) return;
  const { style } = document.body;
  style.position = '';
  style.top = '';
  style.left = '';
  style.right = '';
  style.width = '';
  document.documentElement.classList.remove('scroll-locked');
  window.scrollTo(0, savedScrollY);
}

/** Component-scoped lock: engages on mount, releases on unmount. */
export function useBodyScrollLock(): void {
  onMounted(lockBodyScroll);
  onBeforeUnmount(unlockBodyScroll);
}
